import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbstractService } from '../../abstractservice';
import { AuthService } from '../../auth.service';
import { FeatureFlagService } from '../../feature-flag.service';

export abstract class AbstractRemoteRepository<TIdentifier, TEntity> extends AbstractService {

    protected cache: Map<TIdentifier, TEntity>;
    public typeInstance: TEntity;

    constructor(
        public identiferPropertySelector: (item: TEntity) => TIdentifier,
        protected http: HttpClient,
        auth: AuthService,
        featureFlagService: FeatureFlagService,
        private type: new () => TEntity) {

        super(auth, featureFlagService);
        this.typeInstance = new type();
    }

    public abstract retrieveHttpCall(id: TIdentifier): Observable<TEntity>;
    public abstract retrieveBulkHttpCall(id: TIdentifier[]): Observable<TEntity[]>;

    public getId(jsonShape: any) {
        return this.identiferPropertySelector(jsonShape);
    }

}
